import { render } from "./SingleItemMenuLayoutEditor.vue?vue&type=template&id=559d68af&ts=true"
import script from "./SingleItemMenuLayoutEditor.vue?vue&type=script&lang=ts"
export * from "./SingleItemMenuLayoutEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__